/**
 * Help table-of-contents section config.
 *
 * Kept exported so the parity test + component tests can assert directly
 * against these lists without duplicating the config. They live outside
 * HelpTOC.jsx so that module exports only its component —
 * react-refresh/only-export-components (stricter as of
 * eslint-plugin-react-refresh 0.5) warns when a file mixes component and
 * non-component exports, because it breaks Vite fast refresh.
 */

export const SECTIONS = [
  { slug: 'quick-start', i18nKey: 'help.toc.sections.quickStart' },
  { slug: 'dashboard', i18nKey: 'help.toc.sections.dashboard' },
  { slug: 'blood-tests', i18nKey: 'help.toc.sections.bloodTests' },
  { slug: 'nutrition', i18nKey: 'help.toc.sections.nutrition' },
  { slug: 'supplements', i18nKey: 'help.toc.sections.supplements' },
  { slug: 'workouts', i18nKey: 'help.toc.sections.workouts' },
  { slug: 'wellness', i18nKey: 'help.toc.sections.wellness' },
  { slug: 'profile', i18nKey: 'help.toc.sections.profile' },
]

export const ADMIN_SECTIONS = [
  { slug: 'demo-environment', i18nKey: 'help.toc.sections.demoEnvironment' },
]
